<template>
  <div class="volume-control flex m-a-between s-a-center">
    <svg class="speaker-icon" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#454F8C" d="M5 7H1v6h4l5 5V2L5 7zm11.36 9.36l-1.41-1.41a6.98 6.98 0 0 0 0-9.9l1.41-1.41a8.97 8.97 0 0 1 0 12.72zm-2.82-2.82l-1.42-1.42a3 3 0 0 0 0-4.24l1.42-1.42a4.98 4.98 0 0 1 0 7.08z"/></svg>
    <div @click="setVolume" class="volume-bar" ref="volume">
      <div class="volume-indicator" :style="`width: ${volume * 100}%;`">
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
export default {
  name: "volumeControl",
  props: ['volume'],
  data: function () {
    return {
      volumeFactor: false,
    };
  },
  mounted () {
    this.volumeFactor = 1.0 / (this.$refs.volume.getBoundingClientRect().right - this.$refs.volume.getBoundingClientRect().left)
  },
  methods: {
    trimFloatRest (number) {
      return number.toFixed(2);
    },
    setVolume (e) {
      const sliderPositionStart = this.$refs.volume.getBoundingClientRect().left;
      const sliderPositionEnd = e.clientX;
      const newVolume = (sliderPositionEnd - sliderPositionStart) * this.volumeFactor;
      bus.$emit('volumeAdjustment', newVolume);
    },
  }
};
</script>

<style scoped>
  .volume-control { flex: 2; }
  .speaker-icon { flex: 1; }
  .volume-bar {
    position: relative;
    background: rgb(232, 232, 232);
    height: 10px;
    border-radius: 20px;
    cursor: pointer;
    overflow: hidden;
    flex: 7;
  }
  .volume-indicator {
    background: hsl(37, 0%, 78%);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 0%;
    transition: width .1s ease;
  }
</style>